import { useMemo } from 'react'
import { useHazardGroupBuckets } from '@app/modules/Risk/Profile/hooks/useHazardGroupBuckets'
import { useElementGroupBuckets } from '@app/modules/Risk/Profile/hooks/useElementGroupBuckets'
import { buildRiskProfileRequest } from '../utils/buildRiskProfileRequest'
import type { ProfileRiskRequest, useRiskProfileRequestOptions } from '../types/riskProfile.types'

export function useRiskProfileRequest({
  queryParams,
  widget,
  pagination,
}: useRiskProfileRequestOptions): ProfileRiskRequest | null {
  const hazardGroupBuckets = useHazardGroupBuckets(queryParams?.hazards ?? [])
  const elementGroupBuckets = useElementGroupBuckets(queryParams?.assets ?? [])

  return useMemo(() => {
    if (queryParams === null) {
      return null
    }

    return buildRiskProfileRequest({
      queryParams,
      widget,
      hazardGroupBuckets,
      elementGroupBuckets,
      pagination,
    })
  }, [elementGroupBuckets, hazardGroupBuckets, queryParams, widget, pagination])
}
